export enum TrackingTypeEnum {
    Dust = 1,
    Noise = 2,
    Gas = 4,
    VOC = 8,
} 